export default function Icon() {
  return (
    <svg
      width="82"
      height="81"
      viewBox="0 0 82 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_12064_5954)">
        <path
          d="M0.944458 14.7363C0.944458 10.8897 2.72845 7.20064 5.90397 4.48068C9.07949 1.76072 13.3864 0.232666 17.8773 0.232666H32.2051V80.5605H17.8773C13.3864 80.5605 9.07949 79.0325 5.90397 76.3125C2.72845 73.5926 0.944458 69.9035 0.944458 66.0569V14.7363Z"
          fill="#6061E5"
        />
        <path
          d="M34.5795 80.1645H66.8199C70.653 80.1645 74.3291 78.3908 77.0394 75.2335C79.7498 72.0763 81.2725 67.7941 81.2725 63.3291V51.6738H34.5795V80.1645Z"
          fill="#73D3CD"
        />
        <path
          d="M81.2725 49.6956V14.8467C81.2725 10.9708 79.7498 7.25369 77.0394 4.51302C74.3291 1.77236 70.653 0.232666 66.8199 0.232666H34.5795V49.6956H81.2725Z"
          fill="#F2D1E2"
        />
      </g>
      <defs>
        <clipPath id="clip0_12064_5954">
          <rect
            x="0.751953"
            width="80.794"
            height="80.794"
            rx="3.16563"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
